import React, { useState } from "react"
import { Button, Card, CardBody, Collapse } from "reactstrap"
import { useNavigate } from "react-router-dom"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"
import ActivityLogFilters from "./ActivityLogFilter"
import { getTimestamp } from "utils/utils"

const ActivityLogsComponents = ({
  data,
  error,
  loading,
  onPageClick,
  onSearch,
  onChangeRowNumber,
  onChangeOrdering,
  onAdvancedSearchSubmit,
}) => {
  const navigate = useNavigate()
  const [filterOpen, setFilterOpen] = useState(false)

  // when filter submited
  const onAdvancedSearchHandler = result => {
    setFilterOpen(result)
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          {/* Custom Header Component */}
          <CustomHeaderTitle
            loading={loading} // loading based data
            title={"List"} // Title of header
            rowCount={true} // show row number select box
            onChangeRowNumber={onChangeRowNumber} // row number select box change
            orderingList={true} // show ordering select box
            onChangeOrdering={onChangeOrdering} //  on ordering select box changed
            searchBox={true} // show search bar
            onSearchHandler={onSearch} // show search has content
            rightBtn={false} // right button contain: Add, Export, Upload, Delete
            advnacedSearchBtn={true} // on advanced search button press ( Open Collapse or Close Collapese)
            advnacedSearchBtnTitle={"Filter"} // Title of Advanced Search Button
            onAdvancedSearch={onAdvancedSearchHandler} // Advanced Search Function
            orderingOptions={[
              { value: "id", name: "ID" },
              { value: "created_at", name: "Created At" },
            ]} // Ordering Options
          />

          {/* Collapse for filter */}
          <Collapse isOpen={filterOpen}>
            {/* Filter Component */}
            <ActivityLogFilters
              loading={loading}
              onAdvancedSearchSubmit={onAdvancedSearchSubmit}
            />
          </Collapse>
          {/* Custom Table for Lists */}
          <GeneralTables
            data={data?.data} // Get Data array
            loading={loading} // loading status True or False
            parentCheckbox={true} // Checkbox status does table have it or not
            headers={["SN", "User", "Role", "Part", "Action", "Date"]} // array for header
            pagination={{ meta: data?.meta, onPageClick: onPageClick }} // pagination attribute
            renderItem={(
              logs,
              index // render items loop
            ) => (
              <tr key={index}>
                <th scope="row">{data?.meta?.from + index}</th>
                <td>{logs?.user?.email}</td>
                <td>{logs?.role}</td>
                <td>{logs?.part}</td>
                <td>{logs?.action}</td>
                <td style={{ whiteSpace: "nowrap" }}>
                  {getTimestamp(logs?.created_at)}
                </td>
              </tr>
            )}
          />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default ActivityLogsComponents
